import { useEffect } from 'react'
import { useAppSelector } from '~publish/legacy/store'
import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'
import SimpleModal from '@bufferapp/ui/SimpleModal'
import Text from '@bufferapp/ui/Text'
import Button from '@bufferapp/ui/Button'
import CheckmarkIcon from '@bufferapp/ui/Icon/Icons/Checkmark'

import { selectAIAssistantPlacement } from '~publish/legacy/ai/state/slice'

import { blue } from '@bufferapp/ui/style/colors'

import ModalActionCreators from '~publish/legacy/composer/composer/shared-components/modal/actionCreators'

import * as Styles from './AIAssistantMPUpgradePlan.styles'
import { useOrganizationId } from '~publish/contexts/AccountContext'

export function AIAssistantMPUpgradePlan({
  ctaButton,
}: {
  ctaButton: string
}): JSX.Element {
  const aiAssistantPlacement = useAppSelector((state) => {
    return selectAIAssistantPlacement(state)
  })

  const organizationId = useOrganizationId()

  useEffect(() => {
    if (aiAssistantPlacement && organizationId) {
      BufferTracker.aIAssistantUpgradeModalViewed({
        organizationId,
        clientName: 'publishWeb',
        cta: `publish-${aiAssistantPlacement}-upgradeModal-${ctaButton}-1`,
      })
    }
  }, [organizationId, aiAssistantPlacement, ctaButton])

  const MIGRATION_HUB_URL =
    'https://account.buffer.com/new-plans?cta=publish-aiAssistant-upgradeModal-findOutMore-1'

  return (
    <SimpleModal
      closeAction={(): void => {
        ModalActionCreators.closeModal()
      }}
    >
      <Styles.Wrapper>
        <Styles.ContentWrapper>
          <Text type="h2">Unlock Buffer&apos;s AI Assistant</Text>
          <Text type="p">
            You&apos;re on a <strong>legacy Buffer plan</strong>. Switch over to
            the newest version to unlock Buffer&apos;s AI Assistant. Plus
            you&apos;ll receive:
          </Text>
          <ul>
            <li>
              <CheckmarkIcon color={blue} />
              Full access to the AI Assistant
            </li>
            <li>
              <CheckmarkIcon color={blue} />
              Unlimited team members (on the team plan)
            </li>
            <li>
              <CheckmarkIcon color={blue} />
              Access to Analytics included on all plans
            </li>
            <li>
              <CheckmarkIcon color={blue} />
              Access to all new AI features guaranteed
            </li>
            <li>
              <CheckmarkIcon color={blue} />
              Access to our beta program
            </li>
            <li>
              <CheckmarkIcon color={blue} />
              Access to Twitter Threads
            </li>
          </ul>
          <Button
            type="primary"
            onClick={(): void => {
              ModalActionCreators.closeModal()
              window.open(MIGRATION_HUB_URL, '_blank')
            }}
            label="Find Out More"
          />
        </Styles.ContentWrapper>
        <Styles.ImageWrapper></Styles.ImageWrapper>
      </Styles.Wrapper>
    </SimpleModal>
  )
}
